module.exports = __webpack_public_path__ + "img/deco-money-1.40904bd.svg";